(function ($) {
  Drupal.behaviors.donationsBlockV1 = {
    attach: function (context) {
      $selectDonationAmount = $('.js-select-donation-amount', context);
      $selectDonationAmount.once().on('change', function () {
        $selectDonation = $(this);
        $selectDonation.parent().siblings('.product__button--add-to-bag').data('sku-base-id', $selectDonation.val());
      });
    }
  };
})(jQuery);
